import { Type, type Static } from "@fastify/type-provider-typebox";
import { AutoFillListPriceFrom, AutoFillListPriceOperation, BoxContentsProvider, FulfillmentType, LabelPrepPreference, PackingType, TransportType } from "./fba";

export enum SkuGenerationMode {
  none = "none", // user manually inputs the sku every time (or uses autopopulated value from inventory item)
  variable = "variable",
  boxemGenerated = "boxemGenerated",
};

export const SettingsBody = Type.Object({
  id: Type.Optional(Type.Integer()),
  fromId: Type.Optional(Type.Union([Type.Integer(), Type.Null()], {default: null})),
  shippingMethod: Type.Optional(Type.Union([Type.Enum(TransportType), Type.Null()])),
  fulfillmentType: Type.Optional(Type.Union([Type.Enum(FulfillmentType), Type.Null()])),
  packingType: Type.Optional(Type.Union([Type.Enum(PackingType), Type.Null()])),
  labelingPreference: Type.Optional(Type.Union([Type.Enum(LabelPrepPreference), Type.Null()])),
  boxContentsPreference: Type.Optional(Type.Union([Type.Enum(BoxContentsProvider), Type.Null()])),
  autoFillListPrice: Type.Optional(Type.Boolean()),
  autoFillListPriceFrom: Type.Optional(Type.Union([Type.Enum(AutoFillListPriceFrom), Type.Null()])),
  autoFillListPriceOperation: Type.Optional(Type.Union([Type.Enum(AutoFillListPriceOperation), Type.Null()])),
  // nullable number, otherwise typebox will convert null to 0
  autoFillListPriceAmount: Type.Optional(Type.Union([Type.Null(), Type.String()], { default: null })), 
  printLabelsEarly: Type.Optional(Type.Boolean()),
  fbmShippingTemplateId: Type.Optional(Type.Integer()),
  skuGenerationOption: Type.Optional(Type.String()),
  skuGenerationFormula: Type.Optional(Type.String()),
  skuGenerationCount: Type.Optional(Type.Integer()),
  printFNSKUAfterAddingToShipment: Type.Optional(Type.Boolean()),
  printFNSKUAfterIncreaseQuantityInShipment: Type.Optional(Type.Boolean()),
  printFNSKUAfterAssigningToBox: Type.Optional(Type.Boolean()),
  printFNSKUAfterIncreaseQuantityInBox: Type.Optional(Type.Boolean()),
});

export const SettingsResponse = Type.Object({
  id: Type.Integer(),
  fromId: Type.Union([Type.Integer(),Type.Null()]),
  shippingMethod: Type.Union([Type.Enum(TransportType), Type.Null()]),
  fulfillmentType: Type.Union([Type.Enum(FulfillmentType), Type.Null()]),
  packingType: Type.Union([Type.Enum(PackingType), Type.Null()]),
  labelingPreference: Type.Union([Type.Enum(LabelPrepPreference), Type.Null()]),
  boxContentsPreference: Type.Union([Type.Enum(BoxContentsProvider), Type.Null()]),
  autoFillListPrice: Type.Boolean(),
  autoFillListPriceFrom: Type.Union([Type.Enum(AutoFillListPriceFrom), Type.Null()]),
  autoFillListPriceOperation: Type.Union([Type.Enum(AutoFillListPriceOperation), Type.Null()]),
  autoFillListPriceAmount: Type.Union([Type.String(), Type.Null()]),
  printLabelsEarly: Type.Boolean(),
  fbmShippingTemplateId: Type.Optional(Type.Integer()),
  skuGenerationOption: Type.String(),
  skuGenerationFormula: Type.String(),
  skuGenerationCount: Type.Integer(),
  printFNSKUAfterAddingToShipment: Type.Optional(Type.Boolean()),
  printFNSKUAfterIncreaseQuantityInShipment: Type.Optional(Type.Boolean()),
  printFNSKUAfterAssigningToBox: Type.Optional(Type.Boolean()),
  printFNSKUAfterIncreaseQuantityInBox: Type.Optional(Type.Boolean()),
});

export type SettingsBody = Static<typeof SettingsBody>;

export type SettingsReponse = Static<typeof SettingsResponse>;

export const GoAuraIntegrationBody = Type.Object({
  goAuraIntegration:  Type.Optional(Type.Boolean()),
  sellerSnapIntegration: Type.Optional(Type.Boolean()),
  bqoolIntegration: Type.Optional(Type.Boolean()),
});

export type GoAuraIntegrationBody = Static<typeof GoAuraIntegrationBody>;

